import React, { Component } from "react";
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ArticleText extends Component {
	state = {
		isMoreOpen: false,
		moreText: 	'More +'
	}
	handleToggle = () => {
		this.setState({ isMoreOpen: !this.state.isMoreOpen });
		if (this.state.isMoreOpen === true) {
			this.setState({moreText: 'More +'});
		} else {
			this.setState({moreText: 'Less -'});
		}
	};
    render () {
	    if (this.props.post) {
		    let post = this.props.post;
		    return (
			    <div>
			        {post.text &&
	    				<div className="c-article__text scope-text scope-text--article" dangerouslySetInnerHTML={ {__html: post.text } }></div>
					}
					{post.expanded_text &&
						<div className={'c-article__accordion ' + (this.state.isMoreOpen ? 'state-open' : "")}>
							<div className="c-article__accordion__body">
								<div className="scope-text scope-text--article" dangerouslySetInnerHTML={ {__html: post.expanded_text} }></div>
							</div>
							<h3 className="c-article__accordion__trigger" onClick={this.handleToggle}>{ this.state.moreText }</h3>
						</div>
					}
				</div>
			)
		} else {
			return null;
		}
	};

};
